import { data }          from './data';
import { planner }          from './planner';

export default class actions {
  static data                  = data;
  static planner               = planner;
}
